import { Breadcrumbs } from "@/components/site/Breadcrumbs";

export const PageHero = ({ eyebrow, title, intro, crumbs, children, aside }) => (
  <section className="hero-wash noise relative overflow-hidden border-b" style={{ borderColor: "rgba(40,91,69,0.1)" }}>
    <div className="container-site relative py-12 sm:py-16 lg:py-20">
      {crumbs ? <Breadcrumbs items={crumbs} /> : null}
      <div className={`mt-6 grid gap-10 ${aside ? "lg:grid-cols-12 lg:items-center" : ""}`}>
        <div className={aside ? "lg:col-span-7" : "max-w-3xl"}>
          {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
          <h1 className="h-display mt-3">{title}</h1>
          {intro ? <p className="lead mt-5 max-w-2xl">{intro}</p> : null}
          {children}
        </div>
        {aside ? <div className="lg:col-span-5">{aside}</div> : null}
      </div>
    </div>
  </section>
);

export const LifestyleImage = ({ id, alt, className = "", priority = false, sizes = "(min-width: 1024px) 40vw, 100vw", caption = true }) => (
  <figure className={`relative overflow-hidden rounded-2xl bg-[#e9efe7] ${className}`}>
    <img
      src={`https://images.unsplash.com/${id}?auto=format&fit=crop&w=1200&q=70`}
      srcSet={[480, 800, 1200, 1600].map((w) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=70 ${w}w`).join(", ")}
      sizes={sizes}
      alt={alt}
      loading={priority ? "eager" : "lazy"}
      fetchpriority={priority ? "high" : "auto"}
      decoding="async"
      width="1200"
      height="900"
      className="img-zoom h-full w-full object-cover"
    />
    {caption ? (
      <figcaption className="absolute bottom-3 left-3 rounded-full bg-white/85 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-[#3d4a42]">
        Lifestyle image · not an Uhlumo product
      </figcaption>
    ) : null}
  </figure>
);
